import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import {
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import MembershipsTable from "./MembershipsTable";
import MembershipFormSystem from "./MembershipFormSystem";

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", "Lato", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 13,
  },
  palette: {
    primary: {
      main: "#2D7FF9",
      light: "#5B9EFA",
      dark: "#1E5FD9",
    },
    background: {
      default: "#F9FAFB",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#212529",
      secondary: "#6C757D",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "13px",
          fontWeight: 500,
          padding: "8px 16px",
          borderRadius: "4px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        contained: {
          "&:hover": {
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          },
        },
      },
    },
  },
});

const MembershipManager = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#F9FAFB",
          py: 4,
          px: 3,
        }}
      >
        <Box sx={{ maxWidth: 1500, mx: "auto" }}>
          {!showForm ? (
            <>
              {/* Header Section */}
              <Box
                sx={{
                  mb: 4,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: "#212529",
                      mb: 0.5,
                    }}
                  >
                    Memberships
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#6C757D" }}>
                    Manage all memberships and their features
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setShowForm(true)}
                  sx={{
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 12px rgba(45, 127, 249, 0.3)",
                    },
                  }}
                >
                  Add New Membership
                </Button>
              </Box>

              {/* Memberships Table */}
              {/* <Paper sx={{ p: 3 }}> */}
              <MembershipsTable />
              {/* </Paper> */}
            </>
          ) : (
            <>
              {/* Back Button */}
              <Box sx={{ mb: 1 }}>
                <Button
                  startIcon={<ArrowBackIcon />}
                  onClick={() => setShowForm(false)}
                  sx={{
                    color: "#6C757D",
                    "&:hover": {
                      backgroundColor: "#F3F4F6",
                    },
                  }}
                >
                  Back to Memberships
                </Button>
              </Box>

              {/* Membership Form */}
              <MembershipFormSystem />
            </>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MembershipManager;
